module.exports = __webpack_public_path__ + "img/ic-navigation.96608e12.svg";